import {Layout, Menu, Breadcrumb, Button, Divider, Select} from 'antd';

import './layout.css'
import Logo from "./Logo";
import {BiFirstAid} from "react-icons/bi";
import ProfileDropdown from "./ProfileDropdown";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import {BrowserView, isMobile, MobileView} from "react-device-detect";
import Icon, {CalculatorOutlined, QuestionCircleOutlined, UploadOutlined} from "@ant-design/icons";
import {Footer} from "antd/es/layout/layout";
import {useEffect, useState} from "react";
import ApiService from "../../../Service/ApiService";

const { Header } = Layout;

const {SubMenu} = Menu;
export default function MainLayout({children})
{
    const {t} = useTranslation();
    const [version, setVersion] = useState('')
    const history = useHistory();
    const key = window.location.pathname;

    const getVersion = async () => {
        const res = await ApiService.RasCheck.GetVersion();
        if(res.success) {
            setVersion(res.data)
        }
    }

    useEffect(() => {
        getVersion()
    }, [])

    return (
        <>
            <Header style={{ position: 'fixed', zIndex: 100, width: '100%', height: 64, paddingLeft: 0, paddingRight: 16 }}>
                <div style={{display: 'flex', alignItems: 'center', alignContent: 'space-between'}}>
                    {/*<Logo/>*/}
                    <Menu
                        style={{marginLeft: 32, flex: 1}}
                        onClick={(item) => {
                            history.push(item.key)
                        }}
                        theme="dark"
                        mode="horizontal"
                        defaultSelectedKeys={[key]}
                    >
                        {
                            (<Menu.Item key={'/app/upload-project'}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img src={'/icons/Upload.svg'} width={16} height={16} style={{marginRight: 4}} /> {t('Upload')}
                                </div>
                            </Menu.Item>)
                        }
                        {
                            (<Menu.Item key={'/app/internal-check'}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img src={'/icons/Check.svg'} width={16} height={16} style={{marginRight: 4}} /> {t('Check')}
                                </div>
                            </Menu.Item>)
                        }
                        {
                            (<Menu.Item key={'/app/comparison-check'}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img src={'/icons/Compare.svg'} width={16} height={16} style={{marginRight: 4}} /> {t('Compare')}
                                </div>
                            </Menu.Item>)
                        }
                        {
                            (<Menu.Item key={'/app/report'}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img src={'/icons/Report.svg'} width={18} height={18} style={{marginRight: 4}} /> {t('Report')}
                                </div>
                            </Menu.Item>)
                        }
                        {
                            (<Menu.Item key={'/app/profile/settings'}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img src={'/icons/Settings.svg'} width={16} height={16} style={{marginRight: 4}} /> {t('Settings')}
                                </div>
                            </Menu.Item>)
                        }
                        {
                            (<Menu.Item key={'/app/help'}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img src={'/icons/How_to.svg'} width={24} height={24} style={{marginRight: 4}} /> {t('How to')}
                                </div>
                            </Menu.Item>)
                        }
                    </Menu>
                    <ProfileDropdown />
                </div>
            </Header>
            <div style={{display: 'flex', flexDirection: 'column', alignContent: 'space-between', marginTop: 80, height: '100%'}}>
                <div style={{flex: 1}}>
                    {children}
                </div>
                <Footer style={{ textAlign: 'left', marginLeft: 32, paddingLeft: 0, paddingTop: 0, backgroundColor: '#e6eef2' }}>Copyright (c) 2023 RAS Review. Free Research Preview. {version}</Footer>
            </div>
        </>
    )
}
